/* External dependencies */
import { gql } from '@apollo/client';

export const listUsersQuery = gql`
  query listUsers($input: ListUsersInput!) {
    listUsers(input: $input) {
      total
      users {
        id
        email
        firstName
        lastName
        groupName
        status
        personalNumber
      }
    }
  }
`;
